export const SUPPORTED_VOICE_NOTE_FORMATS = [
  {
    ext: 'wav',
    mime: ['audio/wav'],
  },
  {
    ext: 'mp3',
    mime: ['audio/mpeg'],
  },
] as const;

export const VOICE_NOTE_FAILED_TO_TRANSCRIBE_MESSAGE_CODE = 'failed_to_transcribe';
export const VOICE_NOTE_NO_TRANSCRIPTION_MESSAGE_CODE = 'no_transcription';
